<template>
  <section>
    <div class="dialog-header">
      <h1>{{ options.title }}</h1>
      <h2>Selecteer er maximaal {{ options.maxCount }}</h2>
    </div>
    <div class="dialog-content">
      <div class="image-container">
        <div
          v-for="image in images"
          :key="image.name"
          class="image-item"
          @click="toggleImage(image)"
          :class="{ selected: isSelected(image) }"
        >
          <img :src="image.url" :alt="image.name" />
          <span class="image-name">{{ image.name }}</span>
        </div>
      </div>
      <div class="button-holder">
        <button class="pill-button secondary" @click="$emit('close')">
          Annuleren
        </button>
        <button class="pill-button" @click="confirmSelection">
          Bevestigen
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ['options', 'callback', 'selection'],
  data() {
    return {
      images: [
        {
          name: 'Beschermende handschoenen',
          url: '/images/pbm-selector/bechermende handschoenen.jpg'
        },
        {
          name: 'Beschermende kleding',
          url: '/images/pbm-selector/bechermende kleding.jpg'
        },
        {
          name: 'Fluoriserende lange broek',
          url: '/images/pbm-selector/fluoriserende lange broek.jpg'
        },
        {
          name: 'Gehoorbescherming',
          url: '/images/pbm-selector/gehoorbescherming.jpg'
        },
        {
          name: 'Gezichtsmasker',
          url: '/images/pbm-selector/gezichtsmasker.jpg'
        },
        {
          name: 'Hoge zichtbaarheidskleding',
          url: '/images/pbm-selector/hoge zichtbaarheidskleding.jpg'
        },
        {
          name: 'Hoofdbescherming',
          url: '/images/pbm-selector/hoofdbescherming.jpg'
        },
        {
          name: 'Oogbescherming',
          url: '/images/pbm-selector/oogbescherming.jpg'
        },
        {
          name: 'Reddingsvest',
          url: '/images/pbm-selector/reddingsvest.jpg'
        },
        {
          name: 'Veiligheidsharnas',
          url: '/images/pbm-selector/veiligheidsharnas.jpg'
        },
        {
          name: 'Veiligheidsschoenen',
          url: '/images/pbm-selector/veiligheidsschoenen.jpg'
        }
      ],
      selectedImages: this.selection ? [...this.selection] : []
    }
  },
  methods: {
    confirmSelection() {
      this.callback(this.selectedImages)
      this.$emit('close')
    },
    toggleImage(image) {
      const index = this.selectedImages.findIndex(
        (img) => img.name === image.name
      )

      if (index > -1) {
        this.selectedImages.splice(index, 1)
      } else {
        if (this.selectedImages.length < this.options.maxCount) {
          this.selectedImages.push(image)
        }
      }
    },
    isSelected(image) {
      return this.selectedImages.some((img) => img.name === image.name)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-header {
  //margin-bottom: 20px;

  h1 {
    margin-bottom: 10px;
  }

  h2 {
    font-size: 14px;
    font-weight: normal;
    color: #666;
  }
}

.image-container {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  //  padding: 10px 0;
  container-type: inline-size;

  @container (max-width: 350px) {
    .image-item {
      flex: 0 0 100%;
    }
  }
}

.image-item {
  cursor: pointer;
  flex: 0 0 calc(50% - 5px);
  border: 2px solid transparent;
  border-radius: 10px;
  padding: 10px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 10px;
  overflow: hidden;

  &:hover {
    box-shadow: var(--default-shadow);
  }

  &.selected {
    border-color: var(--sub-color);
    //box-shadow: var(--default-shadow);
  }

  img {
    width: 58px;
    height: 58px;
    object-fit: cover;
    border-radius: 4px;
    flex-shrink: 0;
  }

  .image-name {
    font-size: 14px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
  }
}

.button-holder {
  button.secondary {
    margin-right: 5px;
  }
}
</style>
